export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  errors?: Record<string, string[]>;
}

export class HttpError extends Error {
  public readonly status: number;
  public readonly problem: ProblemDetails;

  constructor(status: number, problem: ProblemDetails) {
    super(problem.detail ?? problem.title ?? `HTTP ${status}`);
    this.name = 'HttpError';
    this.status = status;
    this.problem = problem;
  }
}

export class ConflictError extends HttpError {
  constructor(problem: ProblemDetails) {
    super(409, problem);
    this.name = 'ConflictError';
  }
}

/** True for an API 404 (mapped to `HttpError` by the client interceptor). */
export function isNotFoundError(error: unknown): boolean {
  return error instanceof HttpError && error.status === 404;
}
